import * as React from 'react';
import { __ } from 'react-i18n';
import {
  Table,
  TableWrapper,
  Body,
} from '../../_helpers/Table/ResponsiveTable';
import Alert from '../../Alert/Alert';
import OrderHistorySingle from './OrderHistorySingle';
import styled from 'styled-components';
import { orderAgainAction } from '../../../containers/App/actions';
import { push } from 'react-router-redux';
import { Loader } from '../../_helpers/Loader/Loader';

interface AccountHistoryListProps {
  orders: any;
  user: any;
  dispatch: any;
}

const CustomTableWrapper = styled(TableWrapper)`
  margin-bottom: 0;
  ${({ theme }) => theme.media(1100)} {
    margin-bottom: 0;
  }
`;

const OrderHistoryList = (props: AccountHistoryListProps) => {
  const { orders, user } = props;
  const [loading, setLoading] = React.useState(false);

  const onClickOrderAgain = async (publicId: string) => {
    setLoading(true);
    await props.dispatch(
      orderAgainAction(publicId, (result) => {
        props.dispatch(push('/kosik'));
      }),
    );
    setLoading(false);
  };

  return (
    <CustomTableWrapper>
      <Loader loading={loading}>
        {orders && orders.orders && orders.orders.length > 0 ? (
          <Table>
            {/*
          <Head>
            <Tr>
              <Th>{__('Obj. číslo')}</Th>
              <Th>{__('Dátum')}</Th>
              <Th>{company ? __('Suma (bez DPH)') : __('Suma (s DPH)')}</Th>
              <Th>{__('Spôsob platby')}</Th>
              <Th className="empty" />
            </Tr>
          </Head>
          */}
            <Body>
              {orders.orders.map((order, index) => (
                <OrderHistorySingle
                  order={order}
                  user={user}
                  key={index}
                  dispatch={props.dispatch}
                  onClickOrderAgain={onClickOrderAgain}
                />
              ))}
            </Body>
          </Table>
        ) : (
          <Alert> {__('Zatiaľ ste nevytvorili žiadnu objednávku')} </Alert>
        )}
      </Loader>
    </CustomTableWrapper>
  );
};

export default OrderHistoryList;
